import Loadable from '../../components/loadable';

const ManageWebsiteGallery = Loadable({
  loader: () => import('../../pages/manage_website/website_gallery/index'),
});

angular.module('gym').value('ManageWebsiteGallery', ManageWebsiteGallery);
